"use strict";

//VENDOR 
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
import balanceText from 'balance-text'; 
//utilities
import focusRing from './utilities/focusRing.js'
import setLoaded from './utilities/setLoaded.js'
import setDevice from './utilities/setDevice.js';
import setElHeightVariables from './utilities/setElHeightVariables.js';
import * as lazyLoad from './utilities/lazyLoad.js'
import * as reveal from './utilities/revealObserver.js'
import * as form from './utilities/formSubmit.js'

//elements
import * as accordion from './elements/accordion.js'
import * as buttonToTop from './elements/buttonToTop.js'
import * as listHover from './elements/listHover.js'
import * as slider from './elements/slider.js'
import * as heroSlider from './elements/heroSlider.js'
import * as modalOverlay from './elements/modalOverlay.js'
import * as projectGallery from './elements/projectGallery.js'
import * as projectFilter from './elements/projectFilter.js'


/* execute functions only on initial window load */
function init() {
  setLoaded();
  setElHeightVariables();
}
init();

/* execute/update functions on each page load */
function reinit() {
  setDevice();
  focusRing();
  balanceText();
  lazyLoad.lazyLoadInstance.update();
  reveal.revealObserver();

  form.contactForm.init();
  form.submitForm.init();

  listHover.setList();
  listHover.setDirectorHover();
  modalOverlay.setOverlay();
  slider.setSlider();
  heroSlider.setSlider();
  accordion.setAccordion();
  buttonToTop.setbuttonToTop();
  projectGallery.setModal();
  projectFilter.setProjectFilter();
}
reinit();

function unload() {
  /* deattach eventListeners/remove lifecycle here if necessary */
  listHover.destroyList();
  modalOverlay.destroyOverlay();

  form.contactForm.removeEventListener();
  form.submitForm.removeEventListener();

  projectGallery.destroyModal();


  // projectFilter.destroyProjectFilter();
  // window.removeEventListener('scroll', headerPin.scrollCheck, {
  //   capture: true,
  //   passive: true  
  // });
  // window.removeEventListener('scroll', slideshow.scrollTrigger, {
  //   capture: true,
  //   passive: true  
  // });
}


//swup
import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupGaPlugin from '@swup/ga-plugin';
import SwupGtmPlugin from '@swup/gtm-plugin';
import SwupJsPlugin from '@swup/js-plugin';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupScrollPlugin from '@swup/scroll-plugin';
import SwupDebugPlugin from '@swup/debug-plugin';

let lastElementClicked;
let currentFiler;

const SwupJsOptions = [
  {
    from: '(.*)',
    to: '(.*)',
    out: (next) => {
      let tl = gsap.timeline({defaults:{ease:"power2.inOut"}});

      document.querySelector('#swup').style.opacity = 1;

      tl
      .to(window, 1.5, {
        scrollTo: 0,
        ease: "power2.inOut"
      })
      .to(document.querySelector('#swup'), 1.5, {
        opacity: 0,
        onComplete: next
      }, 0);

      console.log('animation-out');
    },
    in: function(next) {
      let tl = gsap.timeline({defaults:{ease:"power2.inOut"}});

      document.querySelector('#swup').style.opacity = 0;

      if (window.location.hash) {
        tl
        .to(window, 1.5, {
          scrollTo: {y: window.location.hash},
          ease: "power2.inOut"
        })
      }

      tl.to(document.querySelector('#swup'), 1, {
        opacity: 1,
        onComplete: next
      });

      console.log('animation-in');
    }
  },
];

const options = {
  containers: ['#swup', '#swup-menu', '#header button'],
  cache: false,
  linkSelector:
    'a[href^="' + 
    window.location.origin +
    '"]:not([data-no-swup]), a[href^="/"]:not([data-no-swup]), a[href^="#"]:not([data-no-swup])',
  skipPopStateHandling: function(event) {
    if (event.state && event.state.source == "swup") {
      return false;
    }
    return true;
  },
  plugins: [
    new SwupBodyClassPlugin(),
    new SwupGaPlugin(),
    new SwupGtmPlugin(),
    new SwupJsPlugin(SwupJsOptions),
    new SwupPreloadPlugin(),
    // new SwupScrollPlugin({
    //   doScrollingRightAway: true, // default false
    //   animateScroll: true, // default true
    //   scrollFriction: .35, // default 0.3
    //   scrollAcceleration: 0.04, // default 0.04
    // }),
    // new SwupDebugPlugin()
  ]
};

const swup = new Swup(options);

swup.on('clickLink', function (event) {
  lastElementClicked = (event.target) ? event.target : event.srcElement;

  if (lastElementClicked.hasAttribute('data-filter')) {
    window.currentFilter = lastElementClicked.getAttribute('data-filter').split('/').pop();;
  } else {
    window.currentFilter = null;
  }

});

swup.on('contentReplaced', () => {
  reinit();
});

// swup.on('transitionEnd', function() {
//   balanceText();
// });

swup.on('transitionStart', function() {
  unload();
});

swup.on('samePageWithHash', function() {
  let tl = gsap.timeline({defaults:{ease:"power2.inOut"}});
  let hash = '';

  if (window.location.hash || event.target.hash) {
    event.preventDefault();

    hash = (window.location.hash) ? window.location.hash : event.target.hash

    tl
    .to(window, 1.5, {
      scrollTo: {
        y: hash,
        // autoKill: true
      }
    })

  }

})